export const ARTICLE_TAGS = [
  'a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi',
  'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption',
  'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd',
  'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element',
  'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3',
  'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input',
  'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu',
  'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p',
  'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'search',
  'section', 'select', 'shadow', 'slot', 'small', 'source', 'spacer', 'span', 'strike',
  'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea',
  'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video',
  'wbr',
]

export const BLOG_TAGS = [...ARTICLE_TAGS, 'iframe']
export const LABEL_TAGS = ['a', 'b', 'strong', 'em', 'i', 'span', 'br']
export const STANDARD_HTML_ATTRIBUTES = [
  'accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete',
  'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture',
  'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols',
  'colspan', 'command', 'commandfor', 'controls', 'controlslist', 'coords', 'crossorigin',
  'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture',
  'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'exportparts',
  'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inert',
  'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop',
  'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted',
  'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'part', 'pattern',
  'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster',
  'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed',
  'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes',
  'slot', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary',
  'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap',
  'xmlns',
]
export const GLOBAL_ATTRIBUTES = [...STANDARD_HTML_ATTRIBUTES, 'aria-*', 'data-*']
export const LINK_ATTRIBUTES = ['href', 'name', 'target', 'rel']
export const IMAGE_ATTRIBUTES = ['src', 'srcset', 'sizes', 'alt', 'title', 'width', 'height', 'loading', 'decoding']
export const SOURCE_ATTRIBUTES = ['src', 'srcset', 'sizes', 'type', 'media', 'width', 'height']
export const MEDIA_ATTRIBUTES = [
  'src', 'controls', 'poster', 'preload', 'autoplay', 'loop', 'muted', 'playsinline',
  'width', 'height', 'crossorigin', 'controlslist', 'disablepictureinpicture', 'disableremoteplayback',
]
export const TRACK_ATTRIBUTES = ['src', 'kind', 'srclang', 'label', 'default']
export const TABLE_ATTRIBUTES = ['colspan', 'rowspan', 'scope', 'headers']
export const IFRAME_ATTRIBUTES = ['src', 'width', 'height', 'title', 'loading', 'allowfullscreen', 'frameborder', 'allow', 'sandbox']
export const SAFE_CSS_VALUE = /^(?!.*(?:\\|\/\*|expression\s*\(|url\s*\(\s*['"]?\s*(?:javascript|data):|@import|-moz-binding))[\s\S]*$/i
export const SAFE_STYLE_PROPERTIES = [
  'background', 'background-color', 'border', 'border-bottom', 'border-color', 'border-left',
  'border-radius', 'border-right', 'border-style', 'border-top', 'border-width', 'color', 'display',
  'float', 'font-family', 'font-size', 'font-style', 'font-weight', 'height', 'letter-spacing',
  'line-height', 'list-style', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top',
  'max-height', 'max-width', 'min-height', 'min-width', 'object-fit', 'padding', 'padding-bottom',
  'padding-left', 'padding-right', 'padding-top', 'text-align', 'text-decoration', 'text-indent',
  'text-transform', 'vertical-align', 'white-space', 'width', 'word-break',
]

export function browserOptions(allowedTags: string[], allowedAttributes: Record<string, string[]>) {
  return {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: [...new Set(Object.values(allowedAttributes).flat().filter(attribute => !attribute.endsWith('*')))],
    ALLOW_ARIA_ATTR: true,
    ALLOW_DATA_ATTR: true,
    FORBID_ATTR: ['srcdoc'],
  }
}
